import axios from '@/axios/api.request'

export const save = (from) => axios.request({
  url: '/patent/cost/save',
  data: from,
  method: 'post'
})

export const edit = (from) => axios.request({
  url: '/patent/cost/edit',
  data: from,
  method: 'post'
})

export const hasten = (id, type) => axios.request({
  url: '/patent/cost/hasten',
  params: { id, type },
  method: 'get'
})